import { Injectable } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';
import * as firebase from 'firebase/app';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  ref = firebase.firestore().collection('users');
  private roleCollection: any;
  private tenantRoleCollection: any;

  constructor(
    private firestore: AngularFirestore,
    public afs: AngularFirestore,
    private httpService: HttpClient
  ) {
    this.roleCollection = this.afs.collection<any>('rolemanagement', ref => ref.orderBy('roleName'));
    this.tenantRoleCollection = this.afs.collection<any>('tenantRoles', ref => ref.orderBy('roleName'));
  }

  generateUniqNumber(length?: any) {
    var length = length || 8,
      charset = "0123456789",
      retVal = "";
    for (var i = 0, n = charset.length; i < length; ++i) {
      retVal += charset.charAt(Math.floor(Math.random() * n));
    }
    return retVal;
  }

  getCorpBudgetList(corpId: any) {
    return new Promise((resolve) => {
      this.firestore.collection('corpBudget', (ref) =>
        ref
          .where("corpId", "==", corpId)
      ).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

  getUsers() {
    return this.firestore.collection('users').snapshotChanges();
  }

  updateUser(uid: string, user: any) {
    return this.afs.doc('admins/' + uid).set(user);
  }

  upsertDepartmentByCorpId(data: any) {
    return this.afs.doc('corpDepartments/' + data.corpId).set(data);
  }

  upsertPurposeByCorpId(data: any) {
    return this.afs.doc('corpPurpose/' + data.corpId).set(data);
  }

  upsertDivisionByCorpId(data: any) {
    return this.afs.doc('corpDivision/' + data.corpId).set(data);
  }

  getAllUsers() {
    return new Promise((resolve) => {
      this.firestore.collection('users').snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

  getAllAdmins() {
    return new Promise((resolve) => {
      this.firestore.collection('admins').snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

  getCrsUsers() {
    return new Promise((resolve) => {
      this.firestore.collection('admins',
        ref => ref.where('organization', '==', 'CorpCRS')).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

  getDepartmentsByCorpId(corpId: any) {
    return new Promise((resolve) => {
      this.firestore.collection('corpDepartments',
        ref => ref.where('corpId', '==', corpId)).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

  getDivisionByCorpId(corpId: any) {
    return new Promise((resolve) => {
      this.firestore.collection('corpDivision',
        ref => ref.where('corpId', '==', corpId)).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

  getPurposeByCorpId(corpId: any) {
    return new Promise((resolve) => {
      this.firestore.collection('corpPurpose',
        ref => ref.where('corpId', '==', corpId)).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

  getUserRole(roleValue: any) {
    return this.firestore.collection<any>('rolemanagement',
      ref => ref.where('roleValue', '==', parseInt(roleValue))).valueChanges();
  }

  getUserById(uid: any) {
    return new Promise((resolve) => {
      this.firestore.collection('admins',
        ref => ref.where('uid', '==', uid)).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

  getAdminById(id: any) {
    return new Promise((resolve) => {
      var docRef = this.firestore.collection("admins").doc(id);

      docRef.ref.get().then(function(doc) {
        if (doc.exists) {
          let res = { ...doc.data(), id: doc.id }
          resolve(res)
        }
      }).catch(function(error) {
        resolve(null);
      });
    })
  }

  getAllRoles() {
    return new Promise((resolve) => {
      this.firestore.collection('rolemanagement',ref =>
      ref.orderBy("timeStamp","desc")
      ).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

  getTenantRoleList(corpId: any) {
    return new Promise((resolve) => {
      this.firestore.collection('rolemanagement', (ref) =>
        ref.where("corpId", "==", corpId)
        .orderBy("timeStamp", "desc")
      ).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

  fethAllRoles() {
    return new Promise((resolve) => {
      this.firestore.collection('rolemanagement',ref=>
      ref.orderBy("timeStamp","desc")
      ).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

  getRoleById(roleValue: any) {
    return new Promise((resolve) => {
      this.firestore.collection('rolemanagement',
        ref => ref.where('roleValue', '==', parseInt(roleValue))).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

  deleteRoleById(id) {
    return this.afs.doc('rolemanagement/' + id).delete();
  }

  deleteTenantRoleById(id) {
    return this.afs.doc('tenantRoles/' + id).delete();
  }

  getCurrentUser(userId): Observable<any> {
    return this.firestore.collection('users', ref => ref.where('uid', '==', userId)).snapshotChanges();
  }

  deleteUserById(id) {
    return this.afs.doc('admins/' + id).delete();
  }

  createUser(user) {
    return this.ref.add(user);
  }

  createRole(role: any) {
    console.log('role before :: upsrer ', role);
    return new Promise((resolve) => {
      if (role.id) {
        this.updateCurrRole(role)
          .then(() => {
            resolve();
          })
      } else {
        this.newRole(role)
          .then(() => {
            resolve();
          })
      }
    })
  }

  createTenantRole(role: any) {
    return new Promise((resolve) => {
      if (role.id) {
        this.updateTenantRole(role)
          .then(() => {
            resolve();
          })
      } else {
        this.newTenantRole(role)
          .then(() => {
            resolve();
          })
      }
    })
  }

  updateCurrRole(role: any) {
    return this.afs.doc<any>('rolemanagement/' + role.id).set(role);
  }

  newRole(role: any) {
    return this.roleCollection.add(role);
  }

  updateTenantRole(role: any) {
    return this.afs.doc<any>('tenantRoles/' + role.id).set(role);
  }

  newTenantRole(role: any) {
    return this.tenantRoleCollection.add(role);
  }

  getUserProfileById(uid: any) {
    return new Promise((resolve) => {
      this.firestore.collection('users',
        ref => ref.where('uid', '==', uid)).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

  getJsonRoomData() {
    return this.httpService.get('../../assets/data/json-data.json');
  }


  getJsonGroupsData() {
    return this.httpService.get('../../assets/data/json-group-data.json');
  }

  getJsonBanquetData() {
    return this.httpService.get('../../assets/data/json-banquet-data.json');
  }

  getSubscriptionData() {
    return this.httpService.get('../../assets/data/json-subscription.json');
  }

  getBlockedCorporateData() {
    return this.httpService.get('../../assets/data/json-blockcorp.json');
  }

  getContributionData() {
    return this.httpService.get('../../assets/data/json-contribution.json');
  }

  getCheckoutReportData() {
    return this.httpService.get('../../assets/data/json-checkout.json');
  }

  getCancelReportData() {
    return this.httpService.get('../../assets/data/json-cancel.json');
  }

  getAmendmentReportData() {
    return this.httpService.get('../../assets/data/json-amend.json');
  }

  getReserveReportData() {
    return this.httpService.get('../../assets/data/json-reserve.json');
  }

  getCorporateData() {
    return this.httpService.get('../../assets/data/json-corporate.json');
  }

  getHotelMasterData() {
    return this.httpService.get('../../assets/data/json-hotelmaster.json');
  }

  getBanquetMasterData() {
    return this.httpService.get('../../assets/data/json-banquestmaster.json');
  }

  getCheckoutData() {
    return this.httpService.get('../../assets/data/json-checkoutroom.json');
  }

  getConfirmRoomData() {
    return this.httpService.get('../../assets/data/json-transaction.json');
  }

  getConfirmBanquetData() {
    return this.httpService.get('../../assets/data/json-banquet-data.json');
  }



}
